import React, { useContext, useEffect, useRef, useState } from 'react';
import displayINRCurrency from '../helpers/displayCurrency';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import addToCart from '../helpers/addToCart';
import Context from '../context';
import { toast } from 'react-toastify';
import SummaryApi from '../common';
import { useParams } from 'react-router-dom';
import fetchAlternativeProduct from '../helpers/fetchAlternativeProduct';
import { FaTag } from 'react-icons/fa6';
import defaultImage from '../assest/DAWACO_White_Icon.png'
import { HiOutlineGift } from 'react-icons/hi';

const AlterCardProduct = ({ type,activePharmaceuticalIngredient,id , heading }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const loadingList = new Array(13).fill(null);

    const [scroll, setScroll] = useState(0);
    const scrollElement = useRef();

    const { fetchUserAddToCart } = useContext(Context);

    // State to manage quantities for each product
    const [quantities, setQuantities] = useState({});

    const [productData, setProductData] = useState([]);
    const params = useParams();

    const fetchProductData = async () => {
        const response = await fetch(SummaryApi.addToCartProductView.url, {
            method: SummaryApi.addToCartProductView.method,
            credentials: 'include',
            headers: {
                "content-type": 'application/json'
            },
        });

        const responseData = await response.json();

        if (responseData.success) {
            setProductData(responseData.data);
        }
    };

    const handleAddToCart = async (e, id,productType) => {
        var cartQuantity = 0;
        var Qty=1
        const targetProduct = productData.find(product => product.productDetails._id === id);
        const targetData = data.find(target => target._id === id);

        if (targetProduct) cartQuantity = targetProduct.quantity;
        
        if(quantities[id]) Qty=quantities[id]

        if ((Qty + cartQuantity) <= targetData.quantity) {
            await addToCart(e, id, Qty,productType);
            fetchUserAddToCart();
        } else {
            toast.error(`لقد وصلت إلي الحد الأقصى المتاح من "${targetData.productName}" فى المخزن`);
        }
        await fetchProductData();
    };

    const fetchData = async () => {
        setLoading(true);
        await fetchProductData();
        const alternativeProduct = await fetchAlternativeProduct(type,activePharmaceuticalIngredient,id);
        setLoading(false);
        setData(alternativeProduct?.data);
    };

    useEffect(() => {
        fetchData();
    }, [activePharmaceuticalIngredient,id]);

    const scrollRight = () => {
        scrollElement.current.scrollLeft += 300;
    };
    const scrollLeft = () => {
        scrollElement.current.scrollLeft -= 300;
    };

    // Helper function to continuously adjust quantity
    const startAdjustingQty = (id, direction) => {
        let interval;
        const adjustQty = () => {
            setQuantities(prevQuantities => {
                const cartQuantity = productData.find(product => product.productDetails._id === id)?.quantity || 0;
                const targetData = data.find(target => target._id === id);

                if (!targetData) return prevQuantities;

                const currentQty = prevQuantities[id] || 1;
                if ((direction === 'increase' && (currentQty + cartQuantity + 1) <= targetData.quantity) || 
                    (direction === 'decrease' && currentQty > 1)) {
                    return { ...prevQuantities, [id]: direction === 'increase' ? currentQty + 1 : currentQty - 1 };
                }
                return prevQuantities;
            });
        };

        interval = setInterval(adjustQty, 100); // Adjust every 100ms

        return () => clearInterval(interval);
    };

    const handleMouseDown = (id, direction) => {
        const stopAdjusting = startAdjustingQty(id, direction);
        const handleMouseUp = () => {
            stopAdjusting();
            window.removeEventListener('mouseup', handleMouseUp);
        };
        window.addEventListener('mouseup', handleMouseUp);
    };

    const handleQuantityChange = (e, id) => {
        let newQuantity = parseInt(e.target.value, 10);

        if (newQuantity < 1) {
            newQuantity = 1;
        }

        const targetProduct = productData.find(product => product.productDetails._id === id);
        const targetData = data.find(target => target._id === id);
        let cartQuantity = targetProduct ? targetProduct.quantity : 0;
        if (newQuantity > targetData.quantity-cartQuantity) {
            newQuantity = targetData.quantity-cartQuantity;
        }

        setQuantities(prev => ({ ...prev, [id]: newQuantity}));
       

    };

     const increaseQty = (id) => {
        const targetProduct = productData.find(product => product.productDetails._id === id);
        const targetData = data.find(target => target._id === id);
        let cartQuantity = targetProduct ? targetProduct.quantity : 0;
        const currentQty = quantities[id] || 1;
    
        if ((currentQty + cartQuantity) < targetData.quantity) {
            setQuantities(prev => ({ ...prev, [id]: (prev[id] || 1) + 1 }));
        } else {
            toast.error(`لقد وصلت إلي الحد الأقصى المتاح من "${targetData.productName}" فى المخزن`);
        }
    };
    
    const decreaseQty = (id) => {
        if ((quantities[id] || 1) > 1) {
            setQuantities(prev => ({ ...prev, [id]: (prev[id] || 1) - 1 }));
        }
    };


    return (
        <div className='container mx-auto px-4 my-6 relative'>
            <h2 className='text-2xl font-semibold py-4'>{heading}</h2>

            <div className='flex items-center gap-4 md:gap-6 overflow-scroll scrollbar-none transition-all' ref={scrollElement}>
                <button className='bg-white shadow-md rounded-full p-1 absolute left-0 text-lg hidden md:block' onClick={scrollLeft}><FaAngleLeft /></button>
                <button className='bg-white shadow-md rounded-full p-1 absolute right-0 text-lg hidden md:block' onClick={scrollRight}><FaAngleRight /></button>

                {loading ? (
                    loadingList.map((_, index) => (
                        <div key={index} className='w-full min-w-[280px] md:min-w-[320px] max-w-[280px] md:max-w-[320px] h-36 bg-white rounded-sm shadow flex'>
                            <div className='bg-slate-200 h-full p-4 min-w-[120px] md:min-w-[145px] animate-pulse'></div>
                            <div className='p-4 grid w-full gap-2'>
                                <h2 className='font-medium text-base md:text-lg text-ellipsis line-clamp-1 text-black bg-slate-200 animate-pulse p-1 rounded-full'></h2>
                                <p className='capitalize text-slate-500 p-1 bg-slate-200 animate-pulse rounded-full'></p>
                                <div className='flex gap-3 w-full'>
                                    <p className='text-blue-600 font-medium p-1 bg-slate-200 w-full animate-pulse rounded-full'></p>
                                    <p className='text-slate-500 line-through p-1 bg-slate-200 w-full animate-pulse rounded-full'></p>
                                </div>
                                <button className='text-sm text-white px-3 py-0.5 rounded-full w-full bg-slate-200 animate-pulse'></button>
                            </div>
                        </div>
                    ))
                ) : (
                    data.map((product, index) => {
                        const isOutOfStock = product?.quantity <= 0;
                        const quantity = quantities[product?._id] || 1;

                        // Determine if the "+" button should be disabled
                        const cartQuantity = productData.find(p => p.productDetails._id === product._id)?.quantity || 0;
                        const isIncreaseDisabled = (quantity + cartQuantity) >= product?.quantity;

                        return (
                            <div key={index} className='w-full min-w-[400px] max-w-[400px] h-[170px] bg-white rounded-sm shadow flex relative rounded'>
                                 {product?.sellingPrice > 0 && (
                            <div className='absolute top-2 right-2 bg-blue-600 text-white px-3 py-1 rounded-full text-sm flex items-center rounded'>
                                <FaTag className='mr-1' />
                                <span>{`${Math.round(((product?.price - product?.sellingPrice) / product?.price) * 100)}% خصم`}</span>
                            </div>
                        )}
                                <div className='w-[330px] h-full bg-slate-200 flex items-center justify-center overflow-hidden'>
                                <Link to={`/product/${product?._id}?type=${product?.type}`}>
                                        <img src={product?.productImage[0] || defaultImage } className='object-cover h-full w-full' alt={product?.productName} />
                                    </Link>
                                </div>
                                <div className='p-4 flex flex-col justify-between w-full'>
                                <Link to={`/product/${product?._id}?type=${product?.type}`} className='flex flex-col'>
                                        <h2 className='font-medium text-base text-ellipsis overflow-hidden whitespace-nowrap'>{product?.productName}</h2>
                                        <p className='capitalize text-slate-500'>{product?.category}  {product?.bonusQuantity > 0 && product?.toBonus > 0 && !isOutOfStock && (
                                                <span className='absolute right-3 text-green-600'>
                                                   <HiOutlineGift style={{ fontSize: '25px' }} />

                                                </span>
                                            )}</p>
                                        <div className='flex gap-3 mt-2'>
                                            {product?.sellingPrice > 0 ? (
                                                <>
                                                    <p className='text-blue-800 font-medium'>{displayINRCurrency(product?.sellingPrice)}</p>
                                                    <p className='text-slate-500 line-through'>{displayINRCurrency(product?.price)}</p>
                                                </>
                                            ) : (
                                                <p className='text-blue-800 font-medium'>{displayINRCurrency(product?.price)}</p>
                                            )}
                                        </div>
                                    </Link>

                                    {isOutOfStock ? (
                                        <span className='text-sm text-red-500 mt-2'>غير متاح حاليا بالمخزن</span>
                                    ) : (
                                        <div className='flex flex-col items-start mt-2'>
                                            <div className='flex items-center mb-2'>
                                                <button
                                                    className='w-8 h-8 flex items-center justify-center border-2 border-blue-800 rounded-full text-gray-800'
                                                    onMouseDown={() => handleMouseDown(product?._id, 'decrease')}
                                                    onClick={() => decreaseQty(product?._id)}   
                                                >
                                                    -
                                                </button>
                                                <input
                                                    type='number'
                                                    className='text-lg font-medium mx-10 w-16 text-center border border-gray-400 rounded'
                                                    value={quantity}
                                                    onChange={(e) => handleQuantityChange(e, product?._id)}
                                                    min={1}
                                                />
                                                <button
                                                    className={`w-8 h-8 flex items-center justify-center border-2 border-blue-800 rounded-full text-gray-800 ${isIncreaseDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                                                    onMouseDown={() => handleMouseDown(product?._id, 'increase')}
                                                    onClick={() => !isIncreaseDisabled && increaseQty(product?._id)}   
                                                    disabled={isIncreaseDisabled} // Disable button when max quantity is reached
                                                >
                                                    +
                                                </button>
                                            </div>
                                            <button
                                                className='text-sm text-white px-3 py-0.5  w-full bg-blue-900 hover:bg-blue-800 rounded'
                                                onClick={(e) => handleAddToCart(e, product?._id,product?.type)}
                                            >
                                                أضف إلى العربة
                                                </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default AlterCardProduct;
